import React, { PropsWithChildren, useCallback } from 'react';
import { FlatList, FlatListProps, StyleSheet } from 'react-native';

import ThemeStyle, { globalSpacing } from '../../Theme/styles';

import CellRenderrer from './CellRenderrer.web';
import Footer from './Footer.web';
import ListContent from './ListContent.web';

export type ScreenWrapperWebProps = PropsWithChildren &
  Partial<FlatListProps<any>> & {
    fullWidth?: boolean;
    header?: React.ComponentType<any>;
    withFooter?: boolean;
    onRef?: (r: FlatList) => void;
  };

const ScreenWrapperWeb: React.FC<ScreenWrapperWebProps> = ({
  children,
  fullWidth,
  header,
  withFooter = true,
  onRef,
  ...rest
}) => {
  const MemoizedFooter = useCallback(
    () => <Footer fullWidth={fullWidth} show={withFooter} />,
    [fullWidth, withFooter],
  );
  return (
    <FlatList
      {...rest}
      ref={(r) => onRef?.(r)}
      contentContainerStyle={styles.flatListContainer}
      data={[0]}
      keyExtractor={(e) => `pageContainer${e}`}
      style={styles.flatListWrapper}
      ListHeaderComponent={header}
      ListFooterComponent={MemoizedFooter}
      CellRendererComponent={CellRenderrer}
      renderItem={() => (
        <ListContent fullWidth={fullWidth}>{children}</ListContent>
      )}
    />
  );
};

const styles = StyleSheet.create({
  flatListWrapper: {
    ...ThemeStyle.pageBackground,
    height: '100dvh',
  },
  flatListContainer: {
    flexGrow: 1,
  },
  contentWrapper: {
    ...ThemeStyle.fitWidthContainer,
    alignSelf: 'center',
    paddingHorizontal: globalSpacing,
  },
});

export default React.memo(ScreenWrapperWeb);
